import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  splash: {
    bg: "rgb(18, 28, 33)",
    gradient:
      "linear-gradient( 90deg, rgba(18.6, 28.22, 33.4, .5) 0, rgba(18.6, 28.22, 33.4, .5) 33.33%, rgba(18.6, 28.22, 33.4, 0) 44.1%, rgba(18.6, 28.22, 33.4, 0) 55.8%, rgba(18.6, 28.22, 33.4, .5) 66.66%, rgba(18.6, 28.22, 33.4, .5))",
    logoFill: "rgb(108, 113, 117)",
    progressBg: "rgb(42, 47, 50)",
    progressAfterBg: "rgb(12, 137, 124)",
    titleColor: "rgba(241, 241, 242, 0.88)",
    subTitleColor: "rgba(241, 241, 242, 0.45)",
    iconColor: "rgba(241, 241, 242, 0.88)",
  },
  layout: {
    bg: "#090F13",
    contentBoxShadowColor: "0 18px 60px rgba(0, 0, 0, 0.45)",
  },
  sidebar: {},
  search: {
    iconColor: "rgba(241, 241, 242, 0.50)",
  },
  options: {
    bg: "rgb(19, 28, 33)",
    boxShadow: "0 18px 60px rgba(0, 0, 0, 0.55)",
  },
  unselectedChat: {
    bg: "rgb(12, 18, 22)",
  },
  chatRoom: {
    bg: "rgb(12, 18, 22)",
    scrollBtnBoxShadow: "0 18px 60px rgba(0, 0, 0, 0.55)",
    profileBoxShadow: "rgba(0, 0, 0, 0.45) 0px 18px 60px 0px",
    profileHeadingColor: "rgb(0, 175, 156)",
    profileActionColor: "rgb(223, 51, 51)",
  },
  common: {
    borderColor: "rgba(255, 255, 255, 0.10)",
    primaryColor: "rgba(255, 255, 255, 0.06)",
    mainHeadingColor: "rgba(241, 241, 242, 0.92)",
    subHeadingColor: "rgba(241, 241, 242, 0.55)",
    secondaryColor: "rgb(12, 18, 22)",
    tertiaryColor: "rgb(0, 175, 156)",
    readIconColor: "#0da9e5",
    unreadIconColor: "#b3b3b3",
    headerIconColor: "rgba(241, 241, 242, 0.60)",

    // Surface tokens (glass UI + input)
    glassBg: "rgba(12, 18, 22, 0.78)",
    glassBorder: "rgba(255, 255, 255, 0.10)",
    glassShadow: "0 10px 24px rgba(0, 0, 0, 0.55)",
    inputBg: "rgba(255, 255, 255, 0.06)",
    inputBorder: "rgba(255, 255, 255, 0.10)",
  },
  alert: {
    infoColor: "#085373",
    iconContainerColor: "rgba(241, 241, 242, 0.8)",
    closeIconColor: "rgba(241, 241, 242, 0.92)",
  },
  badge: {
    textColor: "rgba(241, 241, 242, 0.92)",
    bgColor: "rgba(241, 241, 242, 0.08)",
  },
  sentMessage: {
    textColor: "rgba(241, 241, 242, 0.95)",
    bgColor: "rgba(0, 175, 156, 0.30)",
  },
  receivedMessage: {
    textColor: "rgba(241, 241, 242, 0.95)",
    bgColor: "rgba(255, 255, 255, 0.06)",
  },
  encryptionMessage: {
    bgColor: "rgba(255, 255, 255, 0.06)",
    textColor: "rgb(250, 217, 100)",
  },
};
